import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from '@app/app/shared/services/message.service';

@Component({
  templateUrl: './nav-filter-item.html',
  selector: 'nav-filter-item'
})
export class NavFilterItemComponent {
  @Input() public label: string;
  @Input() public value: any;
  @Input() public checked: boolean;
  @Output() public toggle: EventEmitter<{ checked: boolean, value: any }> = new EventEmitter();

  constructor (private messageService: MessageService) {
  }

  public onChange($event) {
    this.messageService.sendMessage($event.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/nav/filter-item/nav-filter-item.component.ts